import AuthService from '../../services/auth.service';
const user = JSON.parse(localStorage.getItem('user'));
export const state = user
    ? { status: { loggedIn: true }, user }
    : { status: { loggedIn: false }, user: null };

export const actions = {
    login({ commit }, {username, password}) {
        return AuthService.login(username, password).then(
            user => {
                commit('loginSuccess', user);
                return Promise.resolve(user);
            },
            error => {
                commit('loginFailure');
                return Promise.reject(error);
            }
        );
    },
    validate({ state }) {
        // Check if user exists in state and localStorage
        const user = state.user || JSON.parse(localStorage.getItem('user'));
        if (!user) return Promise.resolve(null);
        return Promise.resolve(user);
    },
    logout({ commit }) {
        AuthService.logout();
        commit('logout');
    },
    register({ commit }, user) {
        return AuthService.register(user).then(
            response => {
                commit('registerSuccess');
                return Promise.resolve(response.data);
            },
            error => {
                commit('registerFailure');
                return Promise.reject(error);
            }
        );
    }
}
export const mutations = {
    loginSuccess(state, user) {
        state.status.loggedIn = true;
        state.user = user;
    },
    loginFailure(state) {
        state.status.loggedIn = false;
        state.user = null;
    },
    logout(state) {
        state.status.loggedIn = false;
        state.user = null;
    },
    registerSuccess(state) {
        state.status.loggedIn = false;
    },
    registerFailure(state) {
        state.status.loggedIn = false;
    }
}
export const getters = {
    getUser(state) {
        return state.user;
    },
    loggedIn(state) {
        return state.status.loggedIn;
    },
}
